/**
 * MODULE: _shared/frontend-shell/src/features/crm/hooks/useTenantCurrency.ts
 * PURPOSE: Memoised tenant currency or locale from CrmContext for amount display
 * DEPENDENCIES: react, ../context/CrmContext, ../utils/formatCurrency
 * PUBLIC_API: useTenantCurrency
 * SIDE_EFFECTS: None
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: ~35/100
 */

import { useMemo } from 'react';
import { useCrm } from '../context/CrmContext';
import { formatCrmCurrency } from '../utils/formatCurrency';

export function useTenantCurrency() {
  const { tenantCurrency, tenantLocale } = useCrm();
  return useMemo(
    () => ({
      currency: tenantCurrency,
      locale: tenantLocale,
      formatCurrency: (amount: number) => formatCrmCurrency(amount, tenantCurrency, tenantLocale),
    }),
    [tenantCurrency, tenantLocale]
  );
}
